import { Text, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

import { truncateWithEllipsis } from "@utils/truncateText";


interface TruncateCellProps {
  value: string | undefined;
  charCount?: number;
}

export const TruncatedCell = ({ value, charCount = 20 }: TruncateCellProps) => {
  if (!value) return "";

  if (value?.length <= charCount) {
    return (
      <Text fz={14} lh={1.5}>
        {value}
      </Text>
    );
  } else
    return (
      <Tooltip
        label={value}
        w={"fit-content"}
        maw={300}
        multiline
        ta={"center"}
        withArrow
        events={{ focus: true, hover: true, touch: true }}>
        <Text fz={14} lh={1.5}>
          {truncateWithEllipsis(value, charCount)}{" "}
          {<IconInfoCircle size={14} color="gray" />}
        </Text>
      </Tooltip>
    );
};
